import { botClient, makeServicePlugin, BaseModel } from '@/bot'

class Group extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'Group'
  // Define default properties here
  static instanceDefaults() {
    return {
      title: "",
      permissions: {},
      chat: {},
      bot_id: "",
      type: "",
      administrators: [],
      member_count: 0,
      bot_managed: false,
      deleted: false,
      invite: false,
      in_group: true,
      banned: false,
      properties: {
        restrictOp: 'or'
      },
      // joins
      geofences: [],
      files: []
    }
  }
}

const servicePath = 'groups'
const servicePlugin = makeServicePlugin({
  Model: Group,
  service: botClient.service(servicePath),
  servicePath
})

const idParse = () => {
  return (context) => {
    let { data } = context

    if (data.id && typeof data.id === 'string') {
      data.id = parseInt(data.id)
    }

    return context
  }
}

// Setup the client-side Feathers hooks.
botClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [idParse()],
    patch: [idParse()],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin